// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Extraction-StudyList-AddTagsModal-module__saveButtonContainer";
var _2 = "webpack-concepts-Extraction-StudyList-AddTagsModal-module__tagsInputContainer";
export { _1 as "saveButtonContainer", _2 as "tagsInputContainer" }
